var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollegelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 46,
    viewBox: "0 0 64 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8417 0H47.7189L52.2101 7.29825H11.7891L16.8417 0Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2101 9.54382H11.7891V45.4736H52.2101V9.54382ZM24.7009 12.9123C24.0808 12.9123 23.5781 13.4149 23.5781 14.0351V19.6491C23.5781 20.2692 24.0808 20.7719 24.7009 20.7719C25.321 20.7719 25.8237 20.2692 25.8237 19.6491V14.0351C25.8237 13.4149 25.321 12.9123 24.7009 12.9123ZM16.2803 14.0351C16.2803 13.415 16.783 12.9123 17.4031 12.9123C18.0232 12.9123 18.5259 13.415 18.5259 14.0351V19.6491C18.5259 20.2692 18.0232 20.7719 17.4031 20.7719C16.783 20.7719 16.2803 20.2692 16.2803 19.6491V14.0351ZM16.2802 34.807C16.2802 34.1869 16.7829 33.6842 17.403 33.6842C18.0231 33.6842 18.5258 34.1869 18.5258 34.807V40.4211C18.5258 41.0412 18.0231 41.5439 17.403 41.5439C16.7829 41.5439 16.2802 41.0412 16.2802 40.4211V34.807ZM30.877 14.0351C30.877 13.4149 31.3797 12.9123 31.9998 12.9123C32.6199 12.9123 33.1226 13.4149 33.1226 14.0351V17.4035C33.1226 18.0236 32.6199 18.5263 31.9998 18.5263C31.3797 18.5263 30.877 18.0236 30.877 17.4035V14.0351ZM31.9995 23.0176C28.2788 23.0176 25.2626 26.0338 25.2626 29.7544V43.2281H38.7363V29.7544C38.7363 26.0337 35.7201 23.0176 31.9995 23.0176ZM38.1758 14.0351C38.1758 13.4149 38.6785 12.9123 39.2986 12.9123C39.9187 12.9123 40.4214 13.4149 40.4214 14.0351V19.6491C40.4214 20.2692 39.9187 20.7719 39.2986 20.7719C38.6785 20.7719 38.1758 20.2692 38.1758 19.6491V14.0351ZM46.5955 12.9123C45.9754 12.9123 45.4727 13.4149 45.4727 14.0351V19.6491C45.4727 20.2692 45.9754 20.7719 46.5955 20.7719C47.2156 20.7719 47.7183 20.2692 47.7183 19.6491V14.0351C47.7183 13.4149 47.2156 12.9123 46.5955 12.9123ZM45.4727 34.807C45.4727 34.1869 45.9754 33.6842 46.5955 33.6842C47.2156 33.6842 47.7183 34.1869 47.7183 34.807V40.4211C47.7183 41.0412 47.2156 41.5439 46.5955 41.5439C45.9754 41.5439 45.4727 41.0412 45.4727 40.4211V34.807Z",
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.332,
    y: 27.5088,
    width: 10.6667,
    height: 17.9649,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.000976562,
    y: 27.5088,
    width: 10.6667,
    height: 17.9649,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegelogo);
export default __webpack_public_path__ + "static/media/college logo.150e6c2e8d6b4d1dc0e6372b4ee8700d.svg";
export { ForwardRef as ReactComponent };